import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from '../api/axios'

const initialState = {
	menu: null,
	isAllowAdmin: false,
	defaultWorkstream: '',
	hiddenProfile: sessionStorage.getItem('hiddenProfile') ?? false
}

export const fetchNavigation = createAsyncThunk(
	'navigation/fetchNavigation',
	async (_, thunkAPI) => {
		try {
			const { data } = await axios.get('/POP_Homepage/Get_MenuFrontEnd_List')
			return data
		} catch (err) {
			return thunkAPI.rejectWithValue(err)
		}
	}
)

const navigationSlice = createSlice({
	name: 'navigation',
	initialState,
	reducers: {
		setNavigation: (state, action) => {
			const menuItems = action.payload.reduce((a, b) => {
				let { mainMenu } = b
				mainMenu = mainMenu.split(' ').join('')

				a[mainMenu] = a[mainMenu] ?? []
				a[mainMenu].push(b)
				return a
			}, {})

			state.menu = menuItems
		},
		setIsAllowAdmin: (state, { payload }) => {
			state.isAllowAdmin = payload
		},
		setDefaultWorkstream: (state, { payload }) => {
			state.defaultWorkstream = payload
		},
		setHiddenProfile: (state, { payload }) => {
			state.hiddenProfile = payload
		}
	},
	extraReducers: builder => {
		builder.addCase(fetchNavigation.fulfilled, (state, action) => {
			const menuItems = action.payload.tb_menu_list_homepage.reduce((a, b) => {
				const { mainMenu } = b
				a[mainMenu] = a[mainMenu] ?? []
				a[mainMenu].push(b)
				return a
			}, {})

			state.menu = menuItems
		})
	}
})

export const { setNavigation, setIsAllowAdmin, setDefaultWorkstream, setHiddenProfile } =
	navigationSlice.actions

export default navigationSlice.reducer
